export default __webpack_public_path__ + "static/108085-6c53b68959bdb73a6a9fd3cd519d14d2.jpg";